import { RoomItem } from "./RoomItem";
import { User } from "./User";

export class ExternalShareLink {
  static COL: string = 'externalshares'; //rooms/externalshares
  public id: string = uuid();
  title: string = '';
  created = new Date();
  updated = new Date();
  roomItems: RoomItem[] = [];
  password: string | null = null;
  expireDate: Date | null = null; // ISOFormat Date
  maxDownloads: number | null = null;
  notifyOnDownload: string | null = null;

  // Populated by backend for display purposes (not stored in DB)
  workspaceName?: string;
  roomName?: string;
  roomProfileImageUrl?: string;

  constructor(public roomId: string, public user: User) {
  }
}

export class ExternalShareLinkDownload {
  static COL: string = 'downloads'; //rooms/externalshares/downloads
  public id: string = uuid();
  created = new Date();
  constructor(public link: ExternalShareLink, public itemId: string, public filename: string, public userId: string | null, public ip: string | null, public userAgent: string | null) {
  }
}

function uuid(): string {
  //uuidv4
  return 'xxxxxxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    // eslint-disable-next-line
    var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}